"use strict";

var _interopRequireWildcard = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _trends = require("@/api/cont/trends");
var _storage = require("@/api/storage");
var _auth = require("@/utils/auth");
var _MultiLanguageInp = _interopRequireDefault(require("@/components/MultiLanguageInp"));
var _multiLanguageDisplay = require("@/utils/multiLanguageDisplay");
var _sortablejs = _interopRequireDefault(require("sortablejs"));
var api = _interopRequireWildcard(require("@/api/cont/customBanner"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    MultiLanguageInp: _MultiLanguageInp.default
  },
  data: function data() {
    return {
      checkFileType: _multiLanguageDisplay.checkFileType,
      dialogVisible: false,
      multiLanguageDisplay: _multiLanguageDisplay.multiLanguageDisplay,
      btn: [],
      activeName: '',
      uploadPath: _storage.uploadPath,
      total: 3,
      type: 0,
      pageSize: 10,
      currentPage: 1,
      tit: '新增',
      id: '',
      loading: false,
      staus: 1,
      // 1新增 2编辑
      form: {
        date: '',
        zipCode: '',
        title: '',
        text: '',
        enable: false,
        url: '',
        brief: ''
      },
      oldIndex: null,
      newIndex: null,
      dataSource: []
    };
  },
  computed: {
    headers: function headers() {
      return {
        'Mu-Token': (0, _auth.getToken)()
      };
    }
  },
  created: function created() {
    // this.btn = this.$route.meta.btn
    // console.log(this.btn, 'dddddddddddddddddd')
    // this.type = this.btn[0].value
    // this.activeName = this.btn[0].value
    this.getTab(this.getList);
  },
  mounted: function mounted() {

    // this.init()
  },
  methods: {
    upload: function upload(e) {
      console.log('dddd');
    },
    upbefore: function upbefore(file) {
      var type = file.type;
      this.loading = true;
      var video = ['mp4', 'wmv'];
      if (video.some(function (item) {
        return type.indexOf(item) >= 0;
      })) {
        if (file.size / 1024 / 1024 > 10) {
          this.$message.error("视频不可大于10M");
          return false;
        }
        return true;
      }
      return this.limg(file, 800);
    },
    getTab: function () {
      var _getTab = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(callback) {
        var res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _trends.pageTab)();
            case 1:
              res = _context.v;
              this.btn = res.data.data;
              this.activeName = this.btn[0]['productType'];
              this.type = this.activeName;
              console.log(res, '333ddd');
              callback && callback();
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t, 'error');
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getTab(_x) {
        return _getTab.apply(this, arguments);
      }
      return getTab;
    }(),
    onEnable: function onEnable(val, value) {
      console.log('val', val, value);
      var data = {
        date: value.date,
        text: value.text,
        title: value.title,
        type: this.type,
        id: value.id,
        zipcode: value.zipCode,
        enable: val,
        url: value.url,
        brief: value.brief
      };
      api.updateApi(data).then(function (res) {
        // this.getList()
      });
    },
    handleClick: function handleClick(tab) {
      console.log(tab, 888);
      var index = tab['index'];
      this.type = this.btn[index]['productType'];
      this.getList();
    },
    handleAvatarSuccess: function handleAvatarSuccess(res) {
      console.log(res);
      this.form.url = res.data.url;
      this.loading = false;
      console.log(this.form.url);
    },
    // 删除
    deleteItem: function deleteItem(item) {
      var _this = this;
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        api.deleteApi({
          id: item.id
        }).then(function (res) {
          _this.getList();
        });
      });
    },
    getList: function getList() {
      var _this2 = this;
      var params = {
        type: this.type,
        page: this.currentPage,
        size: this.pageSize
      };
      api.listCategoryBanner(params).then(function (res) {
        console.log(res);
        _this2.dataSource = res.data.data.list;
        _this2.total = res.data.data.total;
      });
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      console.log(val);
      this.currentPage = val;
      this.getList();
    },
    add: function add(type) {
      this.dialogVisible = true;
      // this.form = {}
      this.form = {
        date: '',
        zipCode: '',
        title: '',
        text: '',
        enable: false,
        url: '',
        brief: ''
      };
      this.staus = 1;
      this.type = type;
    },
    edit: function edit(item) {
      this.dialogVisible = true;
      this.tit = '编辑';
      this.staus = 2;
      this.id = item.id;
      this.form.date = item.date;
      this.form.enable = item.enable;
      this.form.zipCode = item.zipcode;
      this.form.title = item.title;
      this.form.text = item.text;
      this.form.url = item.url;
      this.form.brief = item.brief;
      this.type = item.type;
    },
    sure: function sure() {
      var _this3 = this;
      var isFormEmpty = this.form.url;
      if (!isFormEmpty) {
        this.$message.error('请上传图片或者视频');
        return;
      }
      var data = {
        date: this.form.date,
        text: this.form.text,
        title: this.form.title,
        type: this.type,
        id: this.id,
        zipcode: this.form.zipCode,
        enable: this.form.enable,
        url: this.form.url,
        brief: this.form.brief
      };
      if (this.staus == 1) {
        api.trendsCreateApi(data).then(function (res) {
          if (res.data.errno == 0) {
            _this3.$message.success('添加成功');
            _this3.dialogVisible = false;
            _this3.getList();
          }
        });
      }
      if (this.staus == 2) {
        api.updateApi(data).then(function (res) {
          console.log(res);
          _this3.$message.success('编辑成功');
          _this3.dialogVisible = false;
          _this3.getList();
        });
      }
    }
  }
};